import { FunctionComponent, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { ROUTE_CONFIG } from "@/routes/config";

import { LoadingOverlay } from "@/components";

import { ScoreCompanyCategory } from "./pages/ScoreCompanyCategory/ScoreCompanyCategory";
import { ScoreProspectCategory } from "./pages/ScoreProspectCategory/ScoreProspectCategory";
import { ScoreCriteria } from "./pages/ScoreCriteria/ScoreCriteria";
import { useLazyGetScoreQuery } from "../../redux/score/score.api";

import { ScoreLoading } from "./pages/ScoreLoading/ScoreLoading";
import { ScoreResponse } from "./schema/score.schema";
import { ScoreOverview } from "./pages/ScoreOverView/ScoreOverview";
import { ScoreChangeLog } from "./pages/ScoreChangeLog/ScoreChangeLog";
import { ScoreGeneral } from "./pages/ScoreGeneral/ScoreGeneral";
import { isScoreStep } from "./shell/scoreSteps";
import { ScoreJobTitles } from "./pages/ScoreJobTitles/ScoreJobTitles";

export const Score: FunctionComponent = () => {
	const [score, setScore] = useState<ScoreResponse | null>(null);

	const [getScore, { isError }] = useLazyGetScoreQuery();

	const location = useLocation();

	const navigate = useNavigate();

	useEffect(() => {
		getScore().then((res) => {
			if (res.data) {
				setScore(res.data);
			}
		});
	}, []);

	useEffect(() => {
		if (!score && !isError) {
			return;
		}

		if (score?.migrationFlag === false) {
			navigate(ROUTE_CONFIG.LEAD_SCORING_LOADING);
		}

		const currentPath = location.pathname.split("/").pop();

		if (isScoreStep(currentPath) || currentPath === "loading") {
			return;
		}

		if (score?.scoreDone) {
			navigate(ROUTE_CONFIG.LEAD_SCORING_OVERVIEW);
		} else if (score?.personasDone) {
			navigate(ROUTE_CONFIG.LEAD_SCORING_CRITERIA);
		} else if (score?.companiesDone) {
			navigate(ROUTE_CONFIG.LEAD_SCORING_PROSPECT);
		} else if (score) {
			navigate(ROUTE_CONFIG.LEAD_SCORING_COMPANY);
		}
	}, [score, isError, location.pathname]);

	return score ? (
		<Routes>
			<Route element={<ScoreCompanyCategory />} path="/company" />
			<Route element={<ScoreProspectCategory />} path="/prospect" />
			<Route element={<ScoreOverview />} path="/overview" />
			<Route element={<ScoreGeneral />} path="/general" />
			<Route element={<ScoreChangeLog />} path="/changelog" />
			<Route element={<ScoreCriteria />} path="/scoring" />
			<Route element={<ScoreJobTitles />} path="/job-titles" />
			<Route element={<ScoreLoading />} path="/loading" />
		</Routes>
	) : isError ? (
		<Routes>
			<Route element={<ScoreLoading />} path="/loading" />
		</Routes>
	) : (
		<LoadingOverlay />
	);
};
